import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from "../../../../context/builder/reducers";
import arrayMove from 'array-move';
import SortableList, { BEST_SERVICES_ITEM } from '../SortableList';
import Input from '../Input';
import TextArea from '../TextArea';


const ItemList = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '', subTitle: '', description: '', link: '',
                elements: []
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });
    const title = props.content.title || '';
    const subTitle = props.content.subTitle || '';
    const description = props.content.description || '';
    let elements = props.content.elements || [];

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const addItem = () => {
        const data = state.data;
        elements = [...elements, { text: '', img: '', title: '' }];
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <SortableList
            item={BEST_SERVICES_ITEM}
            titleComponent="Best services"
            title={props.content.title || ''}
            subTitle={props.content.subTitle || ''}
            description={props.content.description || ''}
            type={props.type}
            elements={elements}
            onChange={onChange}
            onSortEnd={onSortEnd}
            deleteButtonHandler={deleteButtonHandler}
            axis="xy"
            useDragHandle
            addItem={addItem}
        >
            <div className="row">
                <div class="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input onChange={onChange} name="title" value={title}/>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input onChange={onChange} name="subTitle" value={subTitle}/>
                    </div>
                </div>
                <div className="col-12">
                    <div>
                        <label>Description</label>
                        <TextArea name="description" value={description || ''} onChange={onChange}/>
                    </div>
                </div>
            </div>
        </SortableList>);
}

export default ItemList;
